import ReactDOM from 'react-dom';
import App from './App';
import store from './store/store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import { en, he, lng } from './globals/i18n/Translate';
import AxiosHOC from './globals/core/Axios/AxiosHOC';
import './index.scss';

i18next.init({
  interpolation: { escapeValue: false },
  lng,
  resources: {
    en: {
      common: en
    },
    he: {
      common: he
    },
  },
});

ReactDOM.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18next}>
      <AxiosHOC>
        <App />
      </AxiosHOC>
    </I18nextProvider>
  </Provider>
  ,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
